import { FC } from 'react';
import {
  CalculateIcon as Calculate,
  CarUsedIcon as CarUsed,
  CarNewIcon as CarNew,
  CarOfferIcon as CarOffer,
  EntryCarIcon as EntryCar,
  FaqIcon as Faq,
  InventoryNavigationIcon as InventoryNavigation,
  MenuHelpIcon as MenuHelp,
  MenuMagazineIcon as MenuMagazine,
  MenuMessagesIcon as MenuMessages,
  MenuMyIcon as MenuMy,
  MenuLoginIcon as MenuLogin,
  MenuSellIcon as MenuSell,
  MenuSavedIcon as MenuSaved,
  MenuSavedSearchesIcon as MenuSavedSearches,
  NotificationIcon as Notification
} from '@move-ui/icons-asset-catalog';

type Props = {
  className?: string;
};

enum MenuIcon {
  EntryCarIcon = 'EntryCarIcon',
  CalculateIcon = 'CalculateIcon',
  CarNewIcon = 'CarNewIcon',
  CarUsedIcon = 'CarUsedIcon',
  CarOfferIcon = 'CarOfferIcon',
  FaqIcon = 'FaqIcon',
  InventoryNavigationIcon = 'InventoryNavigationIcon',
  MenuHelpIcon = 'MenuHelpIcon',
  MenuSavedIcon = 'MenuSavedIcon',
  MenuMagazineIcon = 'MenuMagazineIcon',
  MenuLoginIcon = 'MenuLoginIcon',
  MenuMessagesIcon = 'MenuMessagesIcon',
  MenuMyIcon = 'MenuMyIcon',
  MenuSellIcon = 'MenuSellIcon',
  MenuSavedSearchesIcon = 'MenuSavedSearchesIcon',
  NotificationIcon = 'NotificationIcon'
}

const MenuIcons: Record<MenuIcon, FC<Props>> = {
  [MenuIcon.EntryCarIcon]: EntryCar,
  [MenuIcon.CalculateIcon]: Calculate,
  [MenuIcon.CarNewIcon]: CarNew,
  [MenuIcon.CarUsedIcon]: CarUsed,
  [MenuIcon.CarOfferIcon]: CarOffer,
  [MenuIcon.FaqIcon]: Faq,
  [MenuIcon.InventoryNavigationIcon]: InventoryNavigation,
  [MenuIcon.MenuHelpIcon]: MenuHelp,
  [MenuIcon.MenuSavedIcon]: MenuSaved,
  [MenuIcon.MenuMagazineIcon]: MenuMagazine,
  [MenuIcon.MenuLoginIcon]: MenuLogin,
  [MenuIcon.MenuMessagesIcon]: MenuMessages,
  [MenuIcon.MenuMyIcon]: MenuMy,
  [MenuIcon.MenuSellIcon]: MenuSell,
  [MenuIcon.MenuSavedSearchesIcon]: MenuSavedSearches,
  [MenuIcon.NotificationIcon]: Notification
};

export default MenuIcons;
export { MenuIcon };
